module.exports = "//public.zight.com/packs/media/images/view-list-active-25ca10080571f6a7440490e12a51494e.svg";